import styled from "styled-components";
import {Container} from "react-bootstrap";

// type LoadingProps = {
//     loading: boolean
// }
//
// export const LoadingContainer = styled.div<LoadingProps>`
//
//   position: fixed;
//   width: 100vw;
//   height: 100vh;
//   top: 0;
//   justify-content: center;
//   align-items: center;
//   background-color: rgba(0,0,0, 0.3);
//   z-index: 5000;
//   display: ${({loading}) => loading ? 'flex': "none"};
//
// `

export const PageProfileContainer = styled.section`
  margin: 0 20px 0 20px;
`
